import {
  DraftIcon,
  HomeIcon,
  MegaphoneIcon,
  NavAlretIcon,
  NavBuildingIcon,
  NavDraftIcon,
  NavHeadPhoneIcon,
  NavHomeIcon,
  NavPushpinIcon,
  NavShoppingIcon,
  NavSurvayIcon,
  ShoppingIcon,
  SurveyIcon,
} from '../components/icon/icon';

const MENU_JOIN_TITLE = '회원가입';
const MENU_FORGOT_TITLE = '아이디 / 비밀번호 찾기';
const JOIN_PATHS = ['/join', '/joinSelect', '/joinCompany', '/joinComplate'];
const FORGOT_PATHS = ['/forgotAccount'];
const MYPAGE_PATH = ['/mypage'];
const COMMON_MYPAGE_TITLE = `마이페이지`;
export const NOT_HEADER_PATHS = ['/', '/login'];
export const FORGOT_TAB_MENU = ['아이디 찾기', '비밀번호 찾기'];
export const ALERT_TAB_MENU = ['받은알림', '보낸알림'];

interface IPathname {
  pathname: string;
}

// 헤더 메뉴 함수
export const menuName = (param: IPathname) => {
  if (JOIN_PATHS.includes(param.pathname)) {
    return MENU_JOIN_TITLE;
  } else if (FORGOT_PATHS.includes(param.pathname)) {
    return MENU_FORGOT_TITLE;
  } else if (MYPAGE_PATH.includes(param.pathname)) {
    return COMMON_MYPAGE_TITLE;
  }
};

// login menu
export const LoginSubscript = [
  { path: '/forgotAccount', search: '?tab=0', title: '아이디 찾기' },
  { path: '/forgotAccount', search: '?tab=1', title: '비밀번호 찾기' },
  { path: '/joinSelect', search: '', title: '회원 가입' },
];

// user footer
export const UserFooterMenu = [
  {
    path: '/userHome',
    title: '홈',
    icon: HomeIcon,
  },
  {
    path: '/userContract',
    title: '수주내역',
    icon: SurveyIcon,
  },
  {
    path: '/userOrder',
    title: '발주정보',
    icon: ShoppingIcon,
  },
  {
    path: '/userDiary',
    title: '일보정리',
    icon: DraftIcon,
  },
  {
    path: '/working',
    title: '일감구함',
    icon: MegaphoneIcon,
  },
];

// manager footer
export const ManagerFooterMenu = [
  {
    path: '/managerHome',
    title: '홈',
    icon: HomeIcon,
  },
  {
    path: '/managerOrder',
    title: '발주정보',
    icon: ShoppingIcon,
  },
  {
    path: '/working',
    title: '일감구함',
    icon: MegaphoneIcon,
  },
];

// auth
export const user = [
  { path: '/userHome', title: '홈', icon: NavHomeIcon },
  {
    path: '/user/favor/company',
    title: '선호 회사 설정',
    icon: NavBuildingIcon,
  },
  { path: '/userContract', title: '수주 내역', icon: NavSurvayIcon },
  { path: '/userOrder', title: '발주 정보', icon: NavShoppingIcon },
  { path: '/userDiary', title: '일보 정리', icon: NavDraftIcon },
  { path: '/working', title: '일감 구함', icon: NavHeadPhoneIcon },
  { path: '/inquiry', title: '1:1 문의', icon: NavHeadPhoneIcon },
  { path: '/notice', title: '공지사항', icon: NavPushpinIcon },
  { path: '/common/alert', title: '알림', icon: NavAlretIcon },
];

export const manager = [
  { path: '/managerHome', title: '홈', icon: NavHomeIcon },
  { path: '/managerOrder', title: '발주 정보', icon: NavShoppingIcon },
  { path: '/working', title: '일감 구함', icon: NavHeadPhoneIcon },
  { path: '/inquiry', title: '1:1 문의', icon: NavHeadPhoneIcon },
  { path: '/notice', title: '공지사항', icon: NavPushpinIcon },
  { path: '/common/alert', title: '알림', icon: NavAlretIcon },
];

// Mypage
export const UserSettingData = [
  { path: '/mypage/passowrdChange', title: '비밀번호 변경' },
  { path: '/mypage/phoneChange', title: '휴대폰 번호 변경' },
  { path: '/mypage/carRegistrationChange', title: '자동차 등록증 변경' },
  { path: '/mypage/user/delegationChange', title: '위임 권한 변경' },
  { path: '/mypage/user/defaultCostSetting', title: '기준 금액 설정' },
];

export const ManagerSettingData = [
  { path: '/mypage/passowrdChange', title: '비밀번호 변경' },
  { path: '/mypage/phoneChange', title: '휴대폰 번호 변경' },
  { path: '/mypage/manager/defaultCostSetting', title: '작업 기준 변경' },
  { path: '/mypage/manager/informationChange', title: '회사 정보 변경' },
  { path: '/mypage/carRegistrationChange', title: '사업자 등록증 변경' },
];
